<template>
  <div class="flex flex_column">
    <Header />
    <div class="personalInfo">
      <div class="container flex">
        <div class="siderbar">
          <div class="navTitle">教育机构服务</div>

          <el-menu
            :default-active="activeIndex"
            :router="true"
            @open="handleOpen"
            @close="handleClose"
            @select="handleSelect"
          >
            <!-- $showEdu -->
            <el-menu-item v-if="true" index="/employerAdmin/admin">
              <i
                :class="
                  `nIcon grxx ${
                    $route.path === '/employerAdmin/admin'
                      ? 'grxx_active'
                      : ''
                  }`
                "
              ></i>
              <!-- {{ $eduType }} -->
              <span slot="title">帐号管理</span>
            </el-menu-item>

            <el-menu-item index="/employerAdmin/feeRefundList">
              <i
                :class="
                  `nIcon grxxbg ${
                    $route.path === '/employerAdmin/feeRefundList'
                      ? 'grxxbg_active'
                      : ''
                  }`
                "
              ></i>
              <span slot="title">费用返还记录</span>
            </el-menu-item>
          </el-menu>
        </div>
        <div class="router-view">
          <div class="title-box" :class="{ hidden: $route.meta.hidden }">
            <div class="title">{{ title || $route.meta.title }}</div>
            <div v-if="$route.meta.hidden" class="back" @click="back">
              <img
                src="https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/icon_arrow_left.png"
                alt=""
                srcset=""
              />
              返回
            </div>
          </div>
          <router-view></router-view>
        </div>
      </div>
    </div>

    <Footer />
  </div>
</template>

<script>
import SiderBar from "@/components/SiderBar";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import { educationalType } from "@/utils/mixins";

export default {
  components: { SiderBar, Header, Footer },
  mixins: [educationalType],
  provide() {
    return {
      $setTitle: this.setTitle
    };
  },
  watch: {
    $route() {
      this.title = "";
    }
  },
  data() {
    return {
      activeIndex: "index",
      activePath: ["1"],
      title: undefined
    };
  },
  created() {
    this.activePath = [this.$route.path];
  },
  methods: {
    setTitle(title) {
      this.title = title;
    },
    handleOpen(key, keyPath) {},
    handleClose() {},
    handleRedirect(path) {
      this.$router.push(path);
    },
    handleSelect(index, indexPath) {
      console.log(index, indexPath);
      this.activeIndex = index;
      this.activePath = indexPath;
    },
    back() {
      this.$router.back();
    }
  }
};
</script>

<style scoped lang="scss">
.container {
  margin-top: 39px;
  margin-bottom: 70px;
}
.flex {
  display: flex;
}
.flex_column {
  flex-direction: column;
}
.personalInfo {
  background: #f0f2f5;
  .siderbar {
    box-sizing: border-box;
    width: 257px;

    padding: 26px 17px 0 18px;
    background: #fff;
    min-height: 903px;
    flex-shrink: 0;
    .navTitle {
      background: #3a61b1;
      color: #f9f9f9;
      font-size: 26px;
      height: 106px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-image: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/xuexuexiao.png");
    }
    .nIcon {
      width: 26px;
      height: 26px;
      display: inline-block;
      background: #dbdbdb;
      margin-right: 18px;
      background-size: cover !important;
    }
    .grxx {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu5.png")
        no-repeat;
    }

    .grxxbg {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu6.png")
        no-repeat;
    }
    .syxslb {
      background: url("../../assets/renyuanmingdan.png") no-repeat;
    }
    .bgcysq {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu7.png")
        no-repeat;
    }
    .cytr {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu8.png")
        no-repeat;
    }
    .el-menu {
      border-right: 0;
    }
    .grxx_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu5_active.png")
        no-repeat;
    }

    .grxxbg_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu6_active.png")
        no-repeat;
    }
    .syxslb_active {
      background: url("../../assets/renyuanmingdan_active.png") no-repeat;
    }
    .bgcysq_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu7_active.png")
        no-repeat;
    }
    .cytr_active {
      background: url("https://chrivc.obs.cn-north-4.myhuaweicloud.com/htmlFile/nMenu8_active.png")
        no-repeat;
    }
  }
  .router-view {
    width: 100%;
    background: #fff;
    margin-left: 17px;
    box-sizing: border-box;
    padding: 40px;
    position: relative;
    .title-box {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 40px;
      &.hidden {
        .title {
          &::before {
            display: none;
          }
        }
      }
      .title {
        font-size: 20px;
        font-family: PingFang SC;
        font-weight: bold;
        color: #393939;
        display: flex;
        align-items: center;
        &::before {
          content: "";
          width: 3px;
          height: 16px;
          background: #3a61b1;
          margin-right: 10px;
        }
      }
      .back {
        display: flex;
        align-items: center;
        cursor: pointer;

        font-size: 20px;
        font-family: PingFang SC;
        font-weight: 500;
        color: #8d8d8d;
        img {
          width: 10px;
          height: 17px;
          margin-right: 12px;
        }
      }
    }
  }
}
.f15 {
  font-size: 15px;
}
.el-menu-item.is-active {
  color: #3a61b1;
  background: rgba(58, 97, 177, 0.12);
}
.el-submenu .el-submenu__title {
  padding-left: 31px !important;
  font-size: 18px;
  display: flex;
  align-items: center;
}
.el-menu-item {
  padding-left: 31px !important;
  font-size: 18px;
}
.el-menu-item-group__title {
  padding: 0;
}
.el-menu-item-group {
  .el-menu-item {
    // padding-left: 40px;
    // padding-left: 31px !important;
    padding-left: 0 !important;
    padding: 0;
    text-align: center;
    line-height: 64px;
    height: 64px;
    font-size: 16px;
    // display: flex;
    // // align-items: center;
    // justify-content: space-around;
    // padding: 0 !important;
    // padding-left: -40px !important;
    // // padding-left: -30px !important;
    // // padding-left: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/employer/admin.vue